var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"overlayContainer",staticClass:"aup-overlay w-100 h-100",class:{ 'd-flex justify-content-center align-items-center': !_vm.sticky},attrs:{"tabindex":"-1"}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }